import { mapGetters, mapActions, mapMutations } from "vuex";

import * as taxCreditStore from "@/store/taxCredit";

export { taxCreditStore };

/**
 * Search store.
 *
 * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
 */
export const createTaxCreditMixin = (without = []) => {
  const actions = !without.includes("actions")
    ? mapActions(taxCreditStore.moduleName, Object.keys(taxCreditStore.actionTypes))
    : {};
  const getters = !without.includes("getters")
    ? mapGetters(taxCreditStore.moduleName, Object.keys(taxCreditStore.getterTypes))
    : {};
  const mutations = !without.includes("mutations")
    ? mapMutations(taxCreditStore.moduleName, Object.keys(taxCreditStore.mutationTypes))
    : {};

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  };
};
